import api from './api';

export function getAppActions(filters = {}) {
    const params = {};
    if (filters.user_id)     params.user_id     = filters.user_id;
    if (filters.action_type) params.action_type = filters.action_type;
    if (filters.start_date)  params.start_date  = filters.start_date;
    if (filters.end_date)    params.end_date    = filters.end_date;
    if (filters.sort_by)     params.sort_by     = filters.sort_by;
    if (filters.sort_order)  params.sort_order  = filters.sort_order;
    if (filters.limit)       params.limit       = filters.limit;
    return api.get('/AppAction', { params }).then(r => r.data);
}

export function getActionTypes() {
    return api.get('/AppAction/types').then(r => r.data);
}
